import React, { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import TopBar from './components/TopBar';
import Footer from './components/Footer';
import CategoryPage from './pages/blogs/CategoryPage';
import SearchPage from './pages/blogs/SearchPage';


// Pages


const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const AdminBlogManager = lazy(() => import('./pages/admin/adminBlogManager'));
const BlogPage = lazy(() => import('./pages/blogs/BlogPage'));
const BlogDetail = lazy(() => import('./pages/blogs/BlogDetail'));
const AllNews = lazy(() => import('./pages/news/AllNews'));
const NewsDetail = lazy(() => import('./pages/news/NewsDetail'));



// Tax Pages
const NtnRegistration = lazy(() => import('./pages/tax/NtnRegistration'));
const IncomeTaxReturn = lazy(() => import('./pages/tax/IncomeTaxReturn'));
const SalesTaxReturn = lazy(() => import('./pages/tax/SalesTaxReturn'));
const TaxAppeals = lazy(() => import('./pages/tax/TaxAppeals'));
const TaxRefund = lazy(() => import('./pages/tax/TaxRefund'));
const ActiveTaxFiler = lazy(() => import('./pages/tax/ActiveTaxFiler'));

// Legal Pages
const CriminalCase = lazy(() => import('./pages/legal/CriminalCase'));
const CivilCase = lazy(() => import('./pages/legal/CivilCase'));
const BankingCase = lazy(() => import('./pages/legal/BankingCase'));
const FamilyCase = lazy(() => import('./pages/legal/FamilyCase'));
const PropertyCase = lazy(() => import('./pages/legal/PropertyCase'));
const FiaCase = lazy(() => import('./pages/legal/FiaCase'));

// Corporate Pages
const CompanyRegistration = lazy(() => import('./pages/corporate/CompanyRegistration'));
const SecpMatters = lazy(() => import('./pages/corporate/SecpMatters'));
const FirmRegistration = lazy(() => import('./pages/corporate/FirmRegistration'));
const NgoRegistration = lazy(() => import('./pages/corporate/NgoRegistration'));
const PecRegistration = lazy(() => import('./pages/corporate/PecRegistration'));
const ChamberOfCommerce = lazy(() => import('./pages/corporate/ChamberOfCommerce'));
const SoftwareHouseRegistration = lazy(() => import('./pages/corporate/SoftwareHouseRegistration'));


// Immigration Pages
const SkilledImmigration = lazy(() => import('./pages/immigration/SkilledImmigration'));
const BusinessImmigration = lazy(() => import('./pages/immigration/BusinessImmigration'));
const StudyVisa = lazy(() => import('./pages/immigration/StudyVisa'));
const VisaAppeals = lazy(() => import('./pages/immigration/VisaAppeals'));
const VisaFilePreparation = lazy(() => import('./pages/immigration/VisaFilePreparation'));

// Loading component — jab page load ho raha ho tab dikhega
function PageLoader() {
  return (
    <div className="flex items-center justify-center min-h-[400px]">
      <div className="w-8 h-8 border-4 border-gold border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

// Reveal on scroll
function RevealOnScroll() {
  const { pathname } = useLocation();
  useEffect(() => {
    const timer = setTimeout(() => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add('visible');
              observer.unobserve(e.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
      );
      document.querySelectorAll('.reveal').forEach(el => {
        el.classList.remove('visible');
        observer.observe(el);
      });
      return () => observer.disconnect();
    }, 100);
    return () => clearTimeout(timer);
  }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <RevealOnScroll />
      <TopBar />
      <Navbar />
      <main>
        {/* ✅ Suspense — lazy pages ka fallback */}
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about-us" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/blog" element={<BlogPage />} />
           <Route path="/:slug" element={<BlogDetail />} />
            <Route path="/wp-admin" element={<AdminBlogManager />} />  {/* News Routes */}
        <Route path="/news" element={<AllNews />} />
        <Route path="/news/:slug" element={<NewsDetail />} />
        <Route path="/category/:categorySlug" element={<CategoryPage />} />
        <Route path="/search" element={<SearchPage />} />

    
            {/* Tax */}
            <Route path="/tax-registration" element={<NtnRegistration />} />
            <Route path="/annual-tax-return" element={<IncomeTaxReturn />} />
            <Route path="/sales-tax-return" element={<SalesTaxReturn />} />
            <Route path="/tax-appeals" element={<TaxAppeals />} />
            <Route path="/tax-refund-in-pakistan" element={<TaxRefund />} />
            <Route path="/active-tax-filer-in-pakistan" element={<ActiveTaxFiler />} />

            {/* Legal */}
            <Route path="/criminal-case" element={<CriminalCase />} />
            <Route path="/civil-case" element={<CivilCase />} />
            <Route path="/banking-case" element={<BankingCase />} />
            <Route path="/family-case" element={<FamilyCase />} />
            <Route path="/property-case" element={<PropertyCase />} />
            <Route path="/fia-case" element={<FiaCase />} />

            {/* Corporate */}
            <Route path="/company-registration" element={<CompanyRegistration />} />
            <Route path="/secp-matters" element={<SecpMatters />} />
            <Route path="/firm-registration" element={<FirmRegistration />} />
            <Route path="/ngo-society-registration" element={<NgoRegistration />} />
            <Route path="/pec-registration-in-pakistan" element={<PecRegistration />} />
            <Route path="/chamber-of-commerce-registration-in-pakistan" element={<ChamberOfCommerce />} />
            <Route path="/software-house-registration" element={<SoftwareHouseRegistration />} />

            {/* Immigration */}
            <Route path="/skilled-immigration-experts-in-pakistan" element={<SkilledImmigration />} />
            <Route path="/business-immigration-consultant-in-pakistan" element={<BusinessImmigration />} />
            <Route path="/study-visa-consultants" element={<StudyVisa />} />
            <Route path="/visa-appeals" element={<VisaAppeals />} />
            <Route path="/visa-file-preparation" element={<VisaFilePreparation />} />
          </Routes>
        </Suspense>
      </main>
      <Footer />
    </BrowserRouter>
  );
}